import React from 'react';
import useReduxState from 'src/hooks/useReduxState';
import HomePageTabsListing from './HomePageTabsListing'

export function HomePageContent(props) {
    const [selectedTab] = useReduxState('', 'searchParams')
    return (
        <>
            <div className="search-page-tab">
                <HomePageTabsListing selectedTab={selectedTab} {...props}/>
            </div>
        </>
    )
}

